import img1 from 'images/login/img1.webp?url'
import img2 from 'images/login/img2.webp?url'
import img3 from 'images/login/img3.webp?url'
import img4 from 'images/login/img4.webp?url'
import img5 from 'images/login/img5.webp?url'
import img6 from 'images/login/img6.jpg?url'
import img7 from 'images/login/img7.webp?url'
import img8 from 'images/login/img8.webp?url'
import img9 from 'images/login/img9.jpg?url'
import img10 from 'images/login/img10.webp?url'

export interface LoginImage {
  path: string
  caption: string
}

const ministerioSaude = 'Fonte: Ministério da Saúde.'
const radilsonGomes = 'Fonte: Radilson Gomes, Ministério da Saúde.'

const image1: LoginImage = { path: img1, caption: ministerioSaude }
const image2: LoginImage = { path: img2, caption: ministerioSaude }
const image3: LoginImage = { path: img3, caption: ministerioSaude }
const image4: LoginImage = { path: img4, caption: ministerioSaude }
const image5: LoginImage = { path: img5, caption: radilsonGomes }
const image6: LoginImage = { path: img6, caption: radilsonGomes }
const image7: LoginImage = { path: img7, caption: radilsonGomes }
const image8: LoginImage = { path: img8, caption: radilsonGomes }
const image9: LoginImage = { path: img9, caption: radilsonGomes }
const image10: LoginImage = { path: img10, caption: radilsonGomes }

export const loginImages: LoginImage[] = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
]

// No período eleitoral a img4 não pode ser exibida
export const loginImagesPeriodoEleitoral: LoginImage[] = [
  image1,
  image2,
  image3,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
]
